<template>
  <b-row>
    <b-col>
      <left-tabs :tabs="tabs" menu="tipo">
        <template #entry>
          <Entry />
        </template>
        <template #transfer>
          <Transfer />
        </template>
        <template #output>
          <Output />
        </template>
        <template #reversal>
          <Reversal />
        </template>
      </left-tabs>
    </b-col>
  </b-row>
</template>

<script>
import LeftTabs from "../Components/LeftTabs";
import Entry from "./movement/entry";
import Output from "./movement/output";
import Transfer from "./movement/transfer";
import Reversal from "./movement/reversal";

import permission from "../../lib/permission";

export default {
  name: "Movement",

  components: { LeftTabs, Entry, Transfer, Output, Reversal },

  data() {
    return {
      tabs: [],
    };
  },

  created() {
    let tabs = [];

    if (permission("write", "main_stock_input")) {
      tabs.push({ title: "ENTRADA", step: "entry" });
    }

    if (permission("write", "main_stock_transfer")) {
      tabs.push({ title: "TRANSFERÊNCIA", step: "transfer" });
    }

    if (permission("write", "main_stock_output")) {
      tabs.push({ title: "SAÍDA", step: "output" });
    }

    if (permission("read", "main_stock_reversal")) {
      tabs.push({ title: "ESTORNO", step: "reversal" });
    }

    this.tabs = tabs;
  },

  methods: {
    permission,
  },
};
</script>

<style>
</style>